import { Component } from "@angular/core";
import { AppConfig } from "../bundles/services.bundle";

@Component({
    selector: "app-footer",
    template: `
    <div class="footer text-center pt-3">
        <span>All Rights Reserved Â© Healthcare Innovation Solutions Inc.<br>Version {{version}}</span>
    </div>
    `
})
export class FooterComponent {
    constructor(public readonly appConfig: AppConfig) {

    }
    version = this.appConfig.getVersion();
}